import { mockVisualData } from '../configs/mockData';

// 根据楼层ID获取楼层信息
export const getFloorById = (floorId: string) => {
  return mockVisualData.floors.find((f) => f.id === floorId);
};

// 获取楼层名称
export const getFloorName = (floorId: string) => {
  const floor = getFloorById(floorId);
  return floor?.name || '未选择';
};

// 获取楼层统计信息
export const getFloorStatistics = (floorId: string) => {
  const floor = getFloorById(floorId);
  return {
    spaces: floor?.spaces || 0,
    occupied: floor?.occupied || 0,
    available: floor?.available || 0
  };
};

// 获取空间类型分布
export const getSpaceTypeDistribution = () => {
  return mockVisualData.spaceTypes;
};

// 获取总体统计信息
export const getOverallStatistics = () => {
  return mockVisualData.statistics;
};
